import { PLASMIC } from './plasmic-init';
import { HeaderMenu } from '~/layout/desktop/Navigation';
import { LoginConditionWrapper } from '~/components/auth/components/LoginConditionWrapper';
import { Link } from '@chakra-ui/next-js';
import { MenuGroup, MenuItem, MenuDivider } from '@chakra-ui/react';
import {
  InfoAccordion,
  InfoAccordionItem,
} from '~/components/ui/accordions/InfoAccordion';
import { OnClickLogin, OnClickLogout } from './attachments/AuthAttachments';
import { OnClickModeChange } from './attachments/ModeChangeAttachments';
import { PlasmicStateContext } from './providers/PlasmicStateContext';
import { UserAvatar } from '~/layout/desktop/UserAvatar';
import { CuratedHomesGrid } from '~/components/ui/grids/CuratedHomesGrid';
import { CuratedProjectsGrid } from '~/components/ui/grids/CuratedProjectsGrid';
import {
  AppHeadingText,
  AppBodyText,
} from '~/components/ui/typography/plasmic';
import { SuggestionsButtonList } from '~/components/ui/tabs/ButtonList';
import { LeadGenerationForm } from '~/components/forms/LeadGenerationForm';
import {
  P0SearchTag,
  P0_SEARCH_TAG_OPTIONS,
} from '~/components/ui/tabs/components/P0SearchTag';

// You can register any code components that you want to use here; see
// https://docs.plasmic.app/learn/code-components-ref/
// And configure your Plasmic project to use the host url pointing at
// the /plasmic-host page of your nextjs app (for example,
// http://localhost:3000/plasmic-host).  See
// https://docs.plasmic.app/learn/app-hosting/#set-a-plasmic-project-to-use-your-app-host

/* Contexts */
PLASMIC.registerGlobalContext(PlasmicStateContext, {
  // name must match GlobalActionsProvider contextName
  name: 'PlasmicStateContext',
  // props must match
  props: {},
  // has <DataProvider>
  providesData: true,
  // globalActions must match the global context's GlobalActionsProvider
  globalActions: {},
});

/* Components */

// @ts-ignore
PLASMIC.registerComponent(HeaderMenu, {
  name: 'DesktopNavigation',
  props: {
    menuTrigger: {
      displayName: 'Menu trigger',
      type: 'slot',
    },
    children: 'slot',
    menuOpenPreview: {
      displayName: 'Menu open (Preview)',
      type: 'boolean',
      defaultValue: true,
    },
    loggedInPreview: {
      displayName: 'Logged in (Preview)',
      type: 'boolean',
      defaultValue: true,
    },
  },
});

PLASMIC.registerComponent(UserAvatar, {
  name: 'UserAvatar',
  props: {},
});

// @ts-ignore
PLASMIC.registerComponent(LoginConditionWrapper, {
  name: 'LoginConditionWrapper',
  props: {
    requiredCondition: {
      type: 'choice',
      options: ['loggedin', 'loggedout'],
      defaultValue: 'loggedin',
    },
    children: 'slot',
    loggedInPreview: {
      displayName: 'Logged in (Preview)',
      type: 'boolean',
      defaultValue: true,
    },
  },
});

PLASMIC.registerComponent(Link, {
  name: 'ChakraLink',
  props: {
    href: {
      type: 'string',
      defaultValue: '/',
    },
    children: 'slot',
  },
});

PLASMIC.registerComponent(MenuGroup, {
  name: 'ChakraMenuGroup',
  props: {
    children: {
      type: 'slot',
    },
    className: 'string',
  },
});

PLASMIC.registerComponent(MenuItem, {
  name: 'ChakraMenuItem',
  props: {
    children: 'slot',
  },
});

PLASMIC.registerComponent(MenuDivider, {
  name: 'ChakraMenuDivider',
  props: {},
});

// @ts-ignore
PLASMIC.registerComponent(InfoAccordion, {
  name: 'InfoAccordion',
  props: {
    items: {
      type: 'slot',
      allowedComponents: ['InfoAccordionItem'],
    },
    className: 'string',
  },
});

// @ts-ignore
PLASMIC.registerComponent(InfoAccordionItem, {
  name: 'InfoAccordionItem',
  props: {
    buttonContent: 'slot',
    panelContent: 'slot',
    className: 'string',
  },
});

/* Attachments */

// @ts-ignore
PLASMIC.registerComponent(OnClickLogin, {
  isAttachment: true,
  styleSections: false, // Attachments should not accept className
  name: 'OnClickLogin',
  props: {
    children: 'slot',
  },
});

// @ts-ignore
PLASMIC.registerComponent(OnClickLogout, {
  isAttachment: true,
  styleSections: false, // Attachments should not accept className
  name: 'OnClickLogout',
  props: {
    children: 'slot',
  },
});

// @ts-ignore
PLASMIC.registerComponent(OnClickModeChange, {
  isAttachment: true,
  styleSections: false, // Attachments should not accept className
  name: 'OnClickModeChange',
  props: {
    mode: {
      type: 'choice',
      options: ['buyer', 'seller', 'broker'],
      defaultValue: 'buyer',
    },
    children: 'slot',
  },
});

// @ts-ignore
PLASMIC.registerComponent(CuratedHomesGrid, {
  name: 'CuratedHomesGrid',
  props: {
    homeIds: {
      displayName: 'Home IDs (comma-separated)',
      type: 'string',
    },
    desktopLayout: {
      displayName: 'Desktop Layout',
      type: 'choice',
      options: ['grid', 'scroll'],
      defaultValue: 'grid',
    },
    debug: {
      displayName: 'DEBUG MODE',
      type: 'boolean',
      defaultValue: false,
    },
  },
});

// @ts-ignore
PLASMIC.registerComponent(CuratedProjectsGrid, {
  name: 'CuratedProjectsGrid',
  props: {
    projectIds: {
      displayName: 'Project IDs (comma-separated)',
      type: 'string',
    },
    desktopLayout: {
      displayName: 'Desktop Layout',
      type: 'choice',
      options: ['grid', 'scroll'],
      defaultValue: 'grid',
    },
  },
});

// @ts-ignore
PLASMIC.registerComponent(AppHeadingText, {
  name: 'AppHeadingText',
  props: {
    text: 'string',
    size: {
      type: 'choice',
      options: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'],
    },
    className: 'string',
  },
});

// @ts-ignore
PLASMIC.registerComponent(AppBodyText, {
  name: 'AppBodyText',
  props: {
    text: 'string',
    size: {
      type: 'choice',
      options: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'],
    },
    className: 'string',
  },
});

// @ts-ignore
PLASMIC.registerComponent(SuggestionsButtonList, {
  name: 'SearchTagsContainer',
  props: {
    children: 'slot',
  },
});

// @ts-ignore
PLASMIC.registerComponent(P0SearchTag, {
  name: 'SearchTag',
  props: {
    tagType: {
      type: 'choice',
      options: Object.keys(P0_SEARCH_TAG_OPTIONS),
    },
  },
});

// @ts-ignore
PLASMIC.registerComponent(LeadGenerationForm, {
  name: 'LeadGenerationForm',
  props: {
    leadType: {
      displayName: 'Lead Type',
      type: 'choice',
      options: ['buyer', 'seller'],
      defaultValue: 'buyer',
    },
    leadSourceId: {
      displayName: 'Lead Source ID (required)',
      type: 'string',
      description: 'Required. The form will not render without a valid lead source ID.',
    },
    assignmentSourceId: {
      displayName: 'Assignment Source ID (required for seller leads)',
      type: 'string',
      description: 'Required for seller leads. Must be provided for AcceptObjectFlow lead sources.',
      hidden: (props: any) => props.leadType !== 'seller',
    },
    brokerId: {
      displayName: 'Assign to Broker ID (optional - skips address matching)',
      type: 'number',
      description: 'If set, leads will be assigned directly to this broker instead of matching by address. Use broker ID from the database.',
    },
    showStreetField: {
      displayName: 'Show Street Field',
      type: 'boolean',
      defaultValue: false,
    },
    showCityField: {
      displayName: 'Show City Field',
      type: 'boolean',
      defaultValue: false,
    },
    showZipField: {
      displayName: 'Show Zip Field',
      type: 'boolean',
      defaultValue: false,
    },
    showTopicField: {
      displayName: 'Show Topic Field',
      type: 'boolean',
      defaultValue: false,
    },
    nameLabel: {
      displayName: 'Name Label',
      type: 'string',
      defaultValue: 'Full Name',
    },
    namePlaceholder: {
      displayName: 'Name Placeholder',
      type: 'string',
      defaultValue: 'Enter your full name (optional)',
    },
    emailLabel: {
      displayName: 'Email Label',
      type: 'string',
      defaultValue: 'Email Address',
    },
    emailPlaceholder: {
      displayName: 'Email Placeholder',
      type: 'string',
      defaultValue: 'Enter your email address (optional)',
    },
    phoneLabel: {
      displayName: 'Phone Label',
      type: 'string',
      defaultValue: 'Phone Number',
    },
    phonePlaceholder: {
      displayName: 'Phone Placeholder',
      type: 'string',
      defaultValue: 'Enter your phone number (optional)',
    },
    streetLabel: {
      displayName: 'Street Label',
      type: 'string',
      defaultValue: 'Street Address',
    },
    streetPlaceholder: {
      displayName: 'Street Placeholder',
      type: 'string',
      defaultValue: 'Enter your street address (optional)',
    },
    cityLabel: {
      displayName: 'City Label',
      type: 'string',
      defaultValue: 'City',
    },
    cityPlaceholder: {
      displayName: 'City Placeholder',
      type: 'string',
      defaultValue: 'Enter your city (optional)',
    },
    zipLabel: {
      displayName: 'Zip Label',
      type: 'string',
      defaultValue: 'Zip Code',
    },
    zipPlaceholder: {
      displayName: 'Zip Placeholder',
      type: 'string',
      defaultValue: 'Enter your zip code (optional)',
    },
    topicLabel: {
      displayName: 'Topic Label',
      type: 'string',
      defaultValue: 'Topic',
    },
    topicPlaceholder: {
      displayName: 'Topic Placeholder',
      type: 'string',
      defaultValue: 'Select topic...',
    },
    valuationTopicLabel: {
      displayName: 'Valuation Topic Label',
      type: 'string',
      defaultValue: 'Property Valuation',
    },
    meetingTopicLabel: {
      displayName: 'Meeting Topic Label',
      type: 'string',
      defaultValue: 'Schedule Meeting',
    },
    claimTopicLabel: {
      displayName: 'Claim Topic Label',
      type: 'string',
      defaultValue: 'Claim Property',
    },
    submitLabel: {
      displayName: 'Submit Label',
      type: 'string',
      defaultValue: 'Send Lead',
    },
  },
});
